import { Component, ElementRef, Inject, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { debounceTime, map } from 'rxjs/operators';
import * as moment from 'moment';
import { MatStepper } from '@angular/material/stepper';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ViaCepService } from 'src/services/via-cep.service';
import { GerencianetService } from 'src/services/gerencianet.service';
//import { PagseguroService } from 'src/services/pagseguro.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import * as STATES from 'src/assets/states.json';
import * as accents from 'remove-accents';
import { CustomValidators } from 'src/validators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
 
const CARD_ERRORS = {
  10000: 'Bandeira do cartão invalida ou não aceita',
  10001: 'Numero do cartão invalido',
  10002: 'Data do cartão invalida',
  10003: 'Código de segurança invalido',
  10004: 'Código de segurança invalido, verifique os numeros e tamanho informado',
  3500062: 'Data de expiração inválida, tente novamente',
  3500058: 'Número de cartão inválido'
}
 
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
 
  paymentMethod: string = 'BILLET';
  form: FormGroup;
  @Output() formObserver: Subject<FormGroup>;
  submitingCardBrand: boolean = false;
  submiting: boolean = false;
  submitted: boolean = false;
  processListName: string = null;
  processListVoucher: string = null;
  enableVoucher: boolean = true;
  planType: string = 'FULL';
  historic: Array<any> = [];
  user: any;
  trialDate: any;
  isSmallScreen$: Observable<boolean>;
  @ViewChild('financeStepper', { static: false }) financeStepper: MatStepper;
  formVoucher: FormGroup;
  boletoUrl: SafeResourceUrl;
  anno: any;
  private signaturePlan: any = null;
  private selectedPlan: any = null;
  errorsAttemps: number = 0;
  showContent : boolean = true;
  methodPay = true;
  currentUser: any;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  selectedTabIndex: number;
  selectedIndex: number;
  CardBillet: boolean;
  states: Array<any> = (STATES as any).default;
  cities: Array<any> = [];
  filteredStates$: Observable<any>;
  filteredCities$: Observable<any>;
  message: string = 'Digite o código do cupom abaixo.';
  success: boolean = false;
  reloadAfter: boolean = true;
  phoneMask: string = '(00) 00000-0000';
  private phoneInputSubject = new Subject<string>();
 
 
  constructor(
    private fb: FormBuilder,
    private http: HttpService,
    private snackbar: MatSnackBar,
    private errorReport: ErrorReportService,
    private breakpoint: BreakpointObserver,
    private renderer: Renderer2,
    private el: ElementRef,
    private sanitizer: DomSanitizer,
    private viaCep: ViaCepService,
    private gerencianet: GerencianetService,
    //private pagseguro: PagseguroService,
    private router: Router,
    // @Inject(MAT_DIALOG_DATA) data: any
  ) {
   
    this.user = JSON.parse(localStorage.getItem('token'));
    this.boletoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.user.payment_link);
 
    this.currentUser = JSON.parse(localStorage.getItem('token'));
    this.form = fb.group({
      step1: this.fb.group({
        brandCard: [null],
        cardNumber: [null, Validators.required],
        holderName: [null, Validators.required],
        cvv: [null, Validators.required],
        expirationDate: [null, Validators.required],
        birthdate: [null, Validators.required],
        //phone:[null, [Validators.required, this.phoneValidator()]],
        cpf: [null, [Validators.required, CustomValidators.cpf]],
        planSelect: [null, Validators.required],
        planName: [null, Validators.required]
      }),
      step2: this.fb.group({
        zipCode: [null, [CustomValidators.cep]],
        email: [null, [Validators.required, Validators.email]],
        phone:[null, [Validators.required, this.phoneValidator()]],
        state: [null, Validators.required],
        stateName: [null],
        city: [null, Validators.required],
        district: [null, Validators.required],
        street: [null, Validators.required],
        number: [null, Validators.required],
        complement: [null],
        fullname: [null, Validators.required],
        cnpj: [null, [Validators.required, CustomValidators.cnpj]],
        companyName: [null, Validators.required],
        acceptEnd: [false]
      })
    });
    this.formVoucher = fb.group({
      user: [this.user.company_id, Validators.required],
      code: [null, Validators.required]
    })
    this.formObserver = new Subject<FormGroup>();
 
    // if (data) {
    //   this.processListName = data.processListName || null;
    //   this.processListVoucher = data.processListVoucher || null;
    //   this.enableVoucher = !!data.processListVoucher || null;
    //   this.reloadAfter = (data.reloadAfter) ? data.reloadAfter : false;
    // }
 
    // this.planType = this.user.company_id ? 'BUSINESS' : 'PERSONAL';
 
    this.phoneInputSubject.pipe(
      debounceTime(300) // Ajuste o tempo conforme necessário
    ).subscribe(input => {
      this.applyPhoneMask(input);
    });
 
  }
 
  ngOnInit(): void {
   
    this.isSmallScreen$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.HandsetPortrait])
      .pipe(
        map(state => {
          return state.matches
        })
      )
 
 
    this.user = JSON.parse(localStorage.getItem('token'));
 
    if (this.user.signature_plan_id) {
      if (
          this.user.signature_plan_id === 'YEARLY_BUSINESS'  
      ) {
          this.selectedPlan = '4';
      } else if (
          this.user.signature_plan_id === 'SIXMONTHLY_BUSINESS'
      ) {
          this.selectedPlan = '3';
      } else if (
          this.user.signature_plan_id === 'TREEMONTHLY_BUSINESS'
      ) {
          this.selectedPlan = '2';
      } else if (
          this.user.signature_plan_id === 'MONTHLY_BUSINESS'
      ) {
          this.selectedPlan = '1';
      }
    }
 
    setTimeout(() => {
      this.form.patchValue({ step1: {planName: this.selectedPlan, planSelect: this.user.signature_plan_id } });
    }, 500);
 
    this.formObserver.next(this.form);
 
    let subject = new Subject();
 
    subject.subscribe(
      (result: any) => {
        const { trigger, scope } = result;
        // if((scope.indexOf('pagseguro') > -1)
        // ||
        if((scope.indexOf('gerencianet') > -1)
        || (scope.indexOf('candidate') > -1)
        ) {
          this.submiting = trigger === 'pre';
        }
       
        if (this.submiting) {
          this.form.disable();
          this.formVoucher.disable();
        } else {
          this.form.enable();
          this.formVoucher.enable();
        }
 
      }
    );
 
    const params = {
      id: this.user.company_id
    }
 
    this.http.setLoadingIndicator(subject);
    //this.trialDate = this.user.signature_date;
    this.http.list('company:valid_trial', params)
      .subscribe(
        (result: any) => {
          const { type, data } = result;
          if (type === 'OK') {
            this.trialDate = data;
          }
        },
        err => this.errorReport.showMessage(err)
      )
   
    //this.pagseguro.getPagseguroSession();
 
    this.form.get('step1.cardNumber')
      .valueChanges
      .pipe(debounceTime(1000))
      .subscribe(
        cardNumber => {
 
          // if (!this.pagseguro.HasPagseguroSession)
          //   return;
 
          const cardBrand = this.form.get('step1.brandCard').value;
          const form = this.form;
 
          if (cardNumber && cardNumber.length >= 6 && cardBrand === null) {
 
            const subject = new Subject<any>();
            subject.subscribe(
              cardBrand => {
                if (cardBrand)
                  form.get('step1.brandCard').setValue(cardBrand);
                else form.get('step1.brandCard').setValue(null);
              }
            )
            this.gerencianet.getCardBrand(cardNumber, subject);
            // this.pagseguro.getCardBrand(cardNumber, subject);
 
          }
 
          if (cardNumber && cardNumber.length < 6)
            form.get('step1.brandCard').setValue(null)
 
        }
      )
 
    this.formObserver.next(this.form);
    this.form.get('step2.zipCode')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        cep => {
          if (!this.form.get('step2.zipCode').invalid) {
            this.viaCep.getLocation(cep)
              .subscribe(
                data => {
                  if (data) {
                    if (data.erro) {
                      alert('CEP inválido por favor tente novamente');
                      this.form.patchValue({
                        step2: {
                          zipCode: ''
                        }
                      });
                    } else {
                      const { bairro, localidade, logradouro, uf } = data;
                      const state = this.states.find(state => state
                        ? state.sigla.toLowerCase() ===
                        uf.toLowerCase() : null);
 
                      this.form.patchValue({
                        step2: {
                        district: bairro,
                        city: localidade,
                        street: logradouro,
                        state: uf,
                        // state: state ? state.sigla : null,
                        stateName: state ? accents.remove(state.nome) : null,
                        // email: localStorage.getItem('email')
                        }
                      }, { emitEvent: false });
                    }
                  }
                }
              )
          }
        }
      )
 
    this.filteredStates$ = this.form.get('step2.state')
      .valueChanges
      .pipe(
        map(state => this._filterStates(state))
      );
 
    this.filteredCities$ = this.form.get('step2.city')
    .valueChanges
    .pipe(map(city => this._filterCities(city)));
 
  }
 
  ngAfterViewInit(): void {
   
    if (this.financeStepper) {
      this.financeStepper.linear = false;
    }
 
    // if (this.user.signature_date) {
    //   setTimeout(() => {
    //     this.choosePlan(this.signaturePlan);
    //   }, 1000);
    // } else {
      this.choosePlan(this.signaturePlan);
      setTimeout(() => {
        this.buscainfo();
      }, 1500);
    // }
 
    setTimeout(() => {
      this.onAcceptEndChange();
    }, 1000);
 
  }
 
  resetPlanSelect() {
    this.form.get('step1.planSelect').reset();
    this.form.markAllAsTouched();
  }
 
  buscainfo() {
   
    this.http.get('profile:info', { id: this.currentUser.id })
    .subscribe(
      (result: any) => {
 
        const { type, data } = result;
        if (type === 'OK') {
          for (const key in data) {
            const value = data[key];
            if (value === 'undefined')
              data[key] = null;
          }
         
          if (data.companycity !== null && data.companycity.split(',').length > 1) {
            var uf = data.companycity?.split(',')[1].trim() ?? '';
            var cidade = data.companycity?.split(',')[0].trim() ?? '';
            var estado = this.states.find(estado => estado.sigla.trim() === uf);
          }else{
            var estado = this.states.find(estado => estado.sigla.trim() === data.companystate);
            var cidade = data.companycity;
          }

          let namefull: string;
 
          if (data.lastname !== null) {
            namefull = data.firstname + ' ' + data.lastname;
          } else {
            namefull = data.firstname;
          }  
 
          this.form.patchValue(
            {
              step2: {
              companyName: data.companyname,
              cnpj: data.cnpj,
              // cpf: data.cpf,
              // birthdate: data.birthdate,
              phone: data.phone,
              gender: data.gender,
              zipCode: data.companyzipcode,
              state: estado.sigla,
              city: cidade,
              district: data.district,
              street: data.companyaddress1,
              number: data.companyaddress2,
              complement: data.complement,
              email: data.email,
              fullname: namefull
              }
            },
            { emitEvent: false }
          );
         
          if (!this.form.valid) {
            this.form.markAllAsTouched();
          }
         
        }
 
      }
    )  
 
  }
 
  onAcceptEndChange() {
    const controls = ['step1.brandCard', 'step1.cardNumber', 'step1.holderName', 'step1.cvv', 'step1.expirationDate', 'step1.cpf', 'step1.birthdate', 'step1.phone'];
    // console.log('alterou', this.paymentMethod);
    if (this.paymentMethod === 'CREDIT_CARD') {
      this.showContent = true;
      controls.forEach(control => {
        const formControl = this.form.get(control);
        if (formControl) {
          this.form.get(control).enable();
          this.form.get(control).setValidators(Validators.required);
          this.form.get(control).updateValueAndValidity();
        }
      });
     
      if (window.innerWidth > 768) {
        setTimeout(() => {
          document.getElementById('holderName').scrollIntoView({ behavior: 'smooth', block: 'start' });
          const zipCodeElement = document.getElementById('cardNumber') as HTMLInputElement;
          if (zipCodeElement) {
            zipCodeElement.focus();
          }
        }, 0);
      }
 
    } else {
      this.showContent = true;
      controls.forEach(control => {
        const formControl = this.form.get(control);
        if (formControl) {
          this.form.get(control).disable();
          this.form.get(control).clearValidators();
          this.form.get(control).updateValueAndValidity();
        }  
      });
    }
  }
 
  submitCode() {
 
    const isValid = !this.formVoucher.invalid;
 
    if (isValid) {
 
      const data = this.formVoucher.getRawValue();
     
      this.http.save('company:cupom', data)
        .subscribe(
          (result: any) => {
 
            if (result.type === 'OK') {
              this.submiting = true;
              const threeMonthsLater = new Date();
              if(data.code == 'OFF01ANO'){
                threeMonthsLater.setDate(threeMonthsLater.getDate() + 365);
              }else{
                threeMonthsLater.setDate(threeMonthsLater.getDate() + 90);
              }
        
              this.success = true;
 
              this.formVoucher.get('code').disable();
              this.formVoucher.get('code').setErrors(null);
              this.formVoucher.get('code').markAsUntouched();
              this.message = `Seu cupom foi inserido com sucesso e vence em ${threeMonthsLater.toLocaleDateString()}.`;
              //this.message = `Seu cupom foi validado com sucesso.`;
              this.snackbar.open(' Seu cupom foi validado com sucesso !!!', 'OK', { duration: 3000 });
 
             
              setTimeout(() => {
                if (this.success) {
                  const outline = this.el.nativeElement.querySelector('.mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline');
                  const outline2 = this.el.nativeElement.querySelector('.mat-form-field-label');
                  const outline3 = this.el.nativeElement.querySelector('.mat-form-field-infix input');
                  if (outline) {
                    this.renderer.setStyle(outline, 'color', 'rgb(14, 219, 14)');
                    this.renderer.setStyle(outline, 'background', '#e5fbe4');
                    this.renderer.setStyle(outline2, 'color', 'rgb(14, 219, 14)');
                    this.renderer.setStyle(outline3, 'font-size', '20px');
                    this.renderer.setStyle(outline3, 'width', '100%');
                    this.renderer.setStyle(outline3, 'color', 'rgb(14, 219, 14)');
                    this.renderer.setStyle(outline3, 'font-weight', '800');
                  }
                }
              }, 200);
 
            } else if (result.type === 'FAIL') {
              this.formVoucher.get('code').setValue(null);
              this.snackbar.open('Seu cupom é inválido ou já foi utilizado, tente com um código válido ou efetue o pagamento', 'OK', { duration: 5000 })
              this.submiting = false;
              this.success = false;
 
            }
 
          },
          err => this.errorReport.showMessage(err),
          () => this.submiting = false
        );
 
    }
 
  }
 
  cancelSignature() {
 
    if(!confirm('Deseja realmente cancelar sua assinaturá do plano atual'))
      return;
   
    const params = {
      id: this.user.id
    }
   
    // this.http.delete('pagseguro:cancel', params)
    this.http.delete('gerencianet:cancel', params)  
      .subscribe(
        (result: any) => {
 
          if(result.type === 'OK') {
            this.snackbar.open('Cancelamento feito com sucesso, acesse sua conta novamente para validação', 'OK', { duration: 3000 })
              .afterDismissed()
              .subscribe(
                () => {                  
                  localStorage.clear();
                  window.location.reload();
                }
              );
           
          } else this.snackbar.open('Não foi possivel cancelar no momento tente novamente mais tarde!', 'OK', { duration: 3000 });
         
        },
        err => this.errorReport.showMessage(err)
      )
 
  }
 
  choosePlan(args) {
   
    if (args && args.index !== undefined) {
      this.signaturePlan = args;
      this.resetPlanSelect();
 
      //if (this.signaturePlan?.index === 0 || this.signaturePlan?.index === 2 || this.signaturePlan?.index === 4) {
        //this.CardBillet = true;
      //} else {
        this.CardBillet = false;
      //}
     
      if (this.CardBillet) {
        // if (this.user.signature_date) {
        //   setTimeout(() => {
        //     this.activateTab(1); // Ativar aba do cartão de crédito
        //     this.deactivateTab(0); // Desativar aba do boleto
        //     this.changePaymentMethod(1);
        //   }, 100);
        // } else {
          // setTimeout(() => {
            this.activateTab(1); // Ativar aba do cartão de crédito
            this.deactivateTab(0); // Desativar aba do boleto
            this.changePaymentMethod(1);
          // }, 500);
        // }
      } else {
        this.activateTab(0); // Ativar aba do boleto  
      }
    }
  }
 
  activateTab(index: number) {
    if (this.tabGroup) {
      this.tabGroup.selectedIndex = index;
      this.tabGroup._tabs.toArray()[index].disabled = false;
    }
  }
 
  deactivateTab(index: number) {
    if (this.tabGroup) {
      this.tabGroup._tabs.toArray()[index].disabled = true;
    }
  }
 
  submit() {
    const isValid = this.toggleVariavel();  
    if (isValid) {
      this.paymentData();
      if (this.paymentMethod == 'BILLET') {
        this.submitBillet();
      }  
      // } else {
      //   this.submitCreditCard();
      // }
    }
  }
 
  changePaymentMethod(index: number) {
    this.paymentMethod = index === 1 ? 'CREDIT_CARD' : 'BILLET';
    // console.log('metodo pag:', this.paymentMethod);
    this.onAcceptEndChange();
  }
 
  paymentData() {
 
    const user = JSON.parse(localStorage.getItem('token'));
    const data = this.form.getRawValue();
    data.userId = user.id;
    data.payment_type = this.paymentMethod;
 
    this.http.save('company:paymentinfo', data)
      .subscribe(
        (result: any) => {
 
          if (result.type === 'OK') {
            //console.log('dados salvos');
          } else if (result.type === 'FAIL') {
            console.error('erro ao salvar os dados');
          }
 
        },
        err => this.errorReport.showMessage(err)
      );
   
  }
 
 
  submitBillet() {
 
    const submitSubject = new Subject<any>();
    const data = {...this.form.getRawValue()};
 
    submitSubject.subscribe(
      result => {
 
        if (result === true)
          this.submiting = true;
        else if (result.type === 'OK') {
 
          this.submiting = false;
          const user = JSON.parse(localStorage.getItem('token'));
          const { data: { id, link } } = result;
 
          user.signature_id = id;
          if (user.signature_date == null) {
            user.signature_status = 'ACTIVE';
          }
 
          localStorage.setItem('token', JSON.stringify(user));
 
          this.submitted = true;
          if (this.signaturePlan && this.signaturePlan.code !== 'MONTHLY')
            window.open(link, '_blank');
 
          setTimeout(() => this.router.navigate(['/recruiter']), 3000);
 
        }
 
      },
      err => {
        this.submiting = false;
        this.snackbar.dismiss();
        const { code } = err;
 
        if (CARD_ERRORS[code] == null && this.errorsAttemps < 5) {
 
          this.submitBillet();
          this.errorsAttemps++;
 
        } else {
 
          const message = CARD_ERRORS[code] || 'Ocorreu um erro desconhecido, verifique os dados informado e tente novamente';
          this.snackbar.open(message, 'OK', { duration: 3000 });
 
        }
      }
    )
 
    data['signaturePlanId'] = this.signaturePlan.code;
 
    if (this.errorsAttemps == 0)
      this.snackbar.open('Gerando seu boleto para pagamento, você será redirecionado para a impressão do boleto em seguida', 'OK');
 
    this.gerencianet.tryPaymentBillet(data, submitSubject);
    //this.pagseguro.tryPayment(data, submitSubject);
 
  }
 
  submitCreditCard() {
 
    const isValid = !this.form.invalid;
 
    if (isValid) {
 
      const data = this.form.getRawValue();
      data.signature_plan_id = this.signaturePlan.code;
      const submitSubject = new Subject<any>();
      data.user = this.user.company_id;
 
      submitSubject.subscribe(
        result => {
 
          if (result === true)
            this.submiting = true;
          else {
 
            this.submiting = false;
            const user = JSON.parse(localStorage.getItem('token'));
            user.signature_id = result.data;
            if (user.signature_date == null) {
              user.signature_status = 'ACTIVE';
            }
            localStorage.setItem('token', JSON.stringify(user));
 
            this.submitted = true;
            // setTimeout(() => window.location.reload(), 8000);
            setTimeout(() => this.router.navigate(['/recruiter']), 8000);
 
          }
 
        },
        err => {
          console.error('ERRO:', err);
          this.submiting = false;
          this.snackbar.dismiss();
          const { code } = err;
         
 
          const message = CARD_ERRORS[code] || 'Ocorreu um erro desconhecido, verifique os dados informado e tente novamente';
          this.errorReport.showMessage(err, message);
          this.snackbar.open(message, 'OK', { duration: 3000 });
 
 
        }
      )
 
      this.snackbar.open('Obrigado por assinar, estamos processando seu pagamento. Por favor aguarde ...', 'OK');
      //this.gerencianet.tryPayment(data, submitSubject);
      // Em caso de uso do pagseguro é necessario descomentar a linha abaixo
      //this.pagseguro.tryPayment(data, submitSubject);
 
    }
 
  }
 
  ngOnDestroy() {
    this.gerencianet.unsubscribe();
   
    // const cardCache = this.pagseguro.hasCardCache();
    // if (cardCache == null) {
    //   this.pagseguro.unsubscribe();
    // }
 
  }
 
  onCompleteInput(args, nextInput = null) {
 
    const { target: { maxLength, value } } = args;
 
    if (value && (value.length >= maxLength) && nextInput) {
 
      const input = document.getElementById(nextInput);
      input.focus();
 
    }
 
  }
 
  public onStateSelected(args: MatAutocompleteSelectedEvent) {
 
    const { option: { value } } = args;
 
    this.form.get('step2.stateName').setValue(accents.remove(value.nome));
    this.http.list('locality:city', { initials: value.sigla })
      .subscribe(
        (cities: any) => {
          this.cities = cities;
        }
      );
 
  }
 
  private _filterCities(city) {
    if (city) {
      city = city.toLowerCase();
      return this.cities.filter(_city => _city.name.toLowerCase().indexOf(city) > -1);
    }
  }
 
  private _filterStates(state) {
 
    if (typeof state !== 'string') return;
 
    let name = accents.remove(state.toLowerCase());
    return this.states.filter(_state => accents.remove(_state.nome).toLowerCase().indexOf(name) > -1
      || _state.sigla.toLowerCase().indexOf(name) > -1);
 
  }
 
  updatePlanSelect(event: any) {
    let selectedValue = event.value;
    let isNumber = !isNaN(selectedValue);
   
    switch (selectedValue) {
      case 'YEARLY_BUSINESS':
        selectedValue = '4';
        break;
      case 'SIXMONTHLY_BUSINESS':
          selectedValue = '3';
        break;
      case 'TREEMONTHLY_BUSINESS':
          selectedValue = '2';
        break;
      case 'MONTHLY_BUSINESS':
          selectedValue = '1';
        break;
    }
 
    let updatedValue
 
    switch (selectedValue) {
      case '4':
        updatedValue = {
          index: 4,
          code: 'YEARLY_BUSINESS',
          title: 'Plano Anual',
          price: '5.058,91',
          installments: 0,
          // descont: '25% OFF',
          period: 'anual',
          selected: false
        };
        break;
      case '3':
        updatedValue = {
          index: 3,
          code: 'SIXMONTHLY_BUSINESS',
          title: 'Plano Semestral',
          price: '2.687,54',
          installments: 0, //2
          // descont: '25% OFF',
          period: 'semestral',
          selected: false
        };
        break;
      case '2':
        updatedValue = {
          index: 2,
          code: 'TREEMONTHLY_BUSINESS',
          title: 'Plano Trimestral',
          price: '1.422,81',
          installments: 0,
          // descont: '- R$50,00',
          period: 'trimestral',
          selected: false
        };
        break;
      case '1':
        updatedValue = {
          index: 1,
          code: 'MONTHLY_BUSINESS',
          title: 'Plano Mensal',
          price: '526,97',
          installments: 0,
          period: 'mensal',
          selected: false
        }
        break;
    }
   
    this.choosePlan(updatedValue);
    this.form.get('step1.planSelect').setValue(updatedValue.code);
    // if (!isNumber) {
    //   setTimeout(() => {
    //     this.form.get('step1.planSelect').setValue(event.value);
    //   }, 200);
    // }
   
  }
 
  findInvalidControl(group: FormGroup | AbstractControl): HTMLElement | null {
    if (group instanceof FormGroup) {
      for (const key of Object.keys(group.controls)) {
        const control = group.get(key);
        if (control instanceof FormGroup) {
          const invalidControl = this.findInvalidControl(control);
          if (invalidControl) {
            return invalidControl;
          }
        } else if (control?.invalid) {
          return document.querySelector(`[formControlName="${key}"]`) as HTMLElement;
        }
      }
    }
    return null;
  }
 
  onBlur() {
    const control = this.form.get('step1.expirationDate');
    if (control && !control.hasValidator(CustomValidators.expirationDate(true))) {
        control.setValidators([
            Validators.required,
            CustomValidators.expirationDate(true)
        ]);
        control.updateValueAndValidity();
    }
  }
 
  getStepIndex(control: HTMLElement): number {
    const step1Fields = this.form.get('step1')?.value;
    const step2Fields = this.form.get('step2')?.value;
 
    if (step1Fields && Object.keys(step1Fields).includes(control.getAttribute('formControlName') || '')) {
      return 0;
    } else if (step2Fields && Object.keys(step2Fields).includes(control.getAttribute('formControlName') || '')) {
      return 1;
    }
 
    return -1;
  }
 
  toggleVariavel() {
    const isValid = !this.form.invalid;
 
    if (isValid) {
      this.showContent = !this.showContent;
      return true;
    } else {
      this.snackbar.open('Por favor, verifique se as informações foram preenchidas corretamente.', 'OK', { duration: 2500 });
     
      // Mark all controls as touched to display validation errors
      this.form.markAllAsTouched();
 
      // Find the first invalid control and scroll to it
      const firstInvalidControl = this.findInvalidControl(this.form);
      if (firstInvalidControl) {
        const stepIndex = this.getStepIndex(firstInvalidControl);
        if (stepIndex !== -1) {
          this.financeStepper.selectedIndex = stepIndex;
        }
        (firstInvalidControl as HTMLElement).focus();
      }
      return false;  // Validação falhou
    }
  }  
 
  onCpfBlur() {
    const cpfControl = this.form.get('step1.cpf');
    if (cpfControl) {
      const cpfError = CustomValidators.cpf(cpfControl);
      if (cpfError) {
        cpfControl.setErrors(cpfError);
      } else {
        cpfControl.setErrors(null);
      }
    }
  }
 
  onPhoneInput(): void {
    const input = this.form.get('step1.phone').value.replace(/\D/g, ''); // Remove tudo que não for dígito
    this.phoneInputSubject.next(input);
  }
 
  private applyPhoneMask(input: string): void {
  
    if (input.length >= 3 && input[2] === '9') {
      this.phoneMask = '(00) 00000-0000'; // Máscara para celular
    } else {
      this.phoneMask = '(00) 0000-0000'; // Máscara para telefone fixo
    }

    const phoneControl = this.form.get('step1.phone');

    // Atualizar validadores antes de chamar updateValueAndValidity
    phoneControl.setValidators([Validators.required, this.phoneValidator()]);

    // Trigger validation check
    phoneControl.updateValueAndValidity({ emitEvent: false });
      
  }
 
  private phoneValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null; // Deixe o validador de 'required' lidar com isso
      }
 
      const input = control.value.replace(/\D/g, ''); // Remove tudo que não for dígito
      const isMobilePhone = input.length === 11 && input[2] === '9';
      const isFixedPhone = input.length === 10 && input[2] !== '9';
 
      if (isMobilePhone || isFixedPhone) {
        return null;
      }
 
      return { invalidLength: true };
    };
  }
 
  validateBirthdate(): void {
    const birthdateControl = this.form.get('step1.birthdate');
    if (birthdateControl) {
      const input = birthdateControl.value.replace(/\//g, ''); // Remove todas as barras
      if (input.length < 8) {
        birthdateControl.setErrors({ invalidDate: true });
      } else {
        // Mantém as outras validações intactas se houver
        if (birthdateControl.errors) {
          delete birthdateControl.errors['invalidDate'];
          if (Object.keys(birthdateControl.errors).length === 0) {
            birthdateControl.setErrors(null);
          }
        }
      }
    }
  }
 
}
 
 